import { fg } from '@atlaskit/platform-feature-flags';
import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import { type ExperienceTrackerAPI } from '@atlassian/conversation-assistant-instrumentation/main';

import { createAifcExperienceCollect } from './create-aifc-experience-collect';

export type UpdateActionRootExperience =
	| typeof ExperienceName.AIFC_UPDATE_CONTENT
	| typeof ExperienceName.UPDATE_CONTENT_IN_CHAT;

type StartUpdateActionExperiencesParams = {
	experienceTracker: ExperienceTrackerAPI;
	conversationId: string;
	rootExperienceName: UpdateActionRootExperience;
	commonExperienceAttributes: Record<string, unknown>;
};

export const startUpdateActionExperiences = ({
	experienceTracker,
	conversationId,
	rootExperienceName,
	commonExperienceAttributes,
}: StartUpdateActionExperiencesParams): void => {
	experienceTracker.start({
		name: rootExperienceName,
		id: conversationId,
		collect: createAifcExperienceCollect(),
		attributes: commonExperienceAttributes,
	});
	// Start AIFC_ALL_DATA_HANDLED - this replaces all explicit AIFC_UPDATE_CONTENT succeed/fail/abort calls
	// Product AIFC integration is responsible for succeeding this experience.
	experienceTracker.start({
		name: ExperienceName.AIFC_ALL_DATA_HANDLED,
		id: conversationId,
		attributes: {
			...commonExperienceAttributes,
			parentExperienceId: rootExperienceName,
		},
	});
	experienceTracker.start({
		name: ExperienceName.AIFC_MESSAGE,
		id: conversationId,
		attributes: {
			...commonExperienceAttributes,
			parentExperienceId: rootExperienceName,
		},
	});

	if (fg('aifc-experience-timeout')) {
		experienceTracker.start({
			name: ExperienceName.AIFC_INITIAL_DATA_RECEIVED,
			id: `${conversationId}-initial`,
			attributes: {
				...commonExperienceAttributes,
				parentExperienceId: rootExperienceName,
			},
		});
	}
};
